import { Chart } from 'react-google-charts';

import { LIGHT_BLUE_400 } from '@pukka/common/constants';
import { Text } from '@pukka/ui-components';
import { twMerge } from 'tailwind-merge';

import { DetailedOutlet } from '../comparison.state';
import { formatter } from '../utils';

import { COMPARISON_DATA_DETAILS, ComparisonVariableNames } from './constants';

const CHART_OPTIONS = {
  title: '',
  isStacked: true,
  fill: 20,
  displayExactValues: true,
  vAxis: { title: '', gridlines: { count: 10, color: 'transparent' } },
  legend: { position: 'none' },
  hAxis: { title: '' },
  colors: [LIGHT_BLUE_400],
  areaOpacity: 1.0,
};

interface ColumnChartProps {
  readonly dataDisplay: ComparisonVariableNames;
  readonly data: DetailedOutlet[];
  readonly className?: string;
}

const DEFAULT_CHART_DATA = [[{ role: 'domain' }, '']];

function generateChartData(dataDisplay: ComparisonVariableNames, data: DetailedOutlet[]) {
  const { title, format } = COMPARISON_DATA_DETAILS[dataDisplay];

  return [
    ...DEFAULT_CHART_DATA,
    ...data.map((obj) => {
      return [
        obj?.name,
        {
          v: obj?.[dataDisplay],
          f: `${title}: ${formatter(format, obj?.[dataDisplay])}`,
        },
      ];
    }),
  ];
}

function ColumnChart({ dataDisplay, data, className }: ColumnChartProps) {
  const chartData = generateChartData(dataDisplay, data);

  const upperCaseTitle = COMPARISON_DATA_DETAILS[dataDisplay].title.toUpperCase();

  return (
    <div data-testid="column-chart" className={twMerge('border border-neutral-100 p-5', className)}>
      <Text variant="caption-1" weight="medium">{`${upperCaseTitle} AMOUNT`}</Text>
      <div className="px-16">
        <Chart chartType="ColumnChart" height="200px" data={chartData} options={CHART_OPTIONS} />
      </div>
    </div>
  );
}

export default ColumnChart;
